module.exports = __webpack_public_path__ + "static/media/index.665a7496.svg";